export const DefaultListItemDisplay = ({
  imageSrc,
  itemName,
  userRole,
}: {
  imageSrc?: string;
  itemName?: string;
  userRole?: string;
}) => (
  <>
    <div className="h-3/4 bg-black w-full grid pointer-events-none">
      <img
        src={imageSrc || "/assets/default-image.jpg"}
        className="w-full h-full object-cover"
      />
    </div>
    {userRole ? (
      <div className="flex flex-col bg-grayBg w-full h-1/4 text-white text-sm font-medium">
        <div className="grid place-content-center">{`${itemName} : ${userRole}`}</div>
      </div>
    ) : (
      <div className="bg-grayBg w-full h-1/4 grid place-content-center text-white text-sm font-medium">
        {itemName}
      </div>
    )}
    <div className="transition absolute top-0 left-0 w-full h-full bg-black/10 opacity-0 group-hover:opacity-100 pointer-events-none" />
  </>
);
